module.exports = __webpack_public_path__ + "static/media/HCMM255.1b5db3ce.jpg";